import type {
  LiveQuoteReloadFormRequest,
  LiveReferentialFormResponse,
} from 'apiConnector/secondary-market/live/models';
import type {
  SecondaryPostEventsLivePersistedTabContent,
  SecondaryQuotesLiveFormPersistedTabContent,
} from 'apiConnector/tabs/secondaryMarket.tabs.model';
import type { LiveForm } from 'state/secondaryMarket/live/form/input/inputForm.model';
import { secondaryMarketInputFormActionsFactory } from 'state/secondaryMarket/shared/form/input/input.actions';

export const liveInputFormActions = secondaryMarketInputFormActionsFactory<
  LiveForm,
  'LIVE',
  LiveQuoteReloadFormRequest,
  LiveReferentialFormResponse,
  SecondaryQuotesLiveFormPersistedTabContent | SecondaryPostEventsLivePersistedTabContent
>('LIVE');

export type LiveInputFormActionFunctions = typeof liveInputFormActions;
export type SecondaryMarketLiveLinkedToClientRequested = ReturnType<LiveInputFormActionFunctions['clientRequested']>;
export type SecondaryMarketLiveLinkedToClientReceived = ReturnType<LiveInputFormActionFunctions['clientReceived']>;
export type SecondaryMarketLiveLinkedToClientFailed = ReturnType<LiveInputFormActionFunctions['clientRequestFailed']>;

export type SecondaryMarketLiveReloadFormFetchRequested = ReturnType<
  LiveInputFormActionFunctions['reloadFormFetchRequested']
>;
export type SecondaryMarketLiveReloadFormFetched = ReturnType<LiveInputFormActionFunctions['reloadFormFetched']>;
export type SecondaryMarketLiveReloadFormFetchedFailed = ReturnType<
  LiveInputFormActionFunctions['reloadFormFetchFailed']
>;

export type SecondaryMarketLiveFormFieldChanged = ReturnType<LiveInputFormActionFunctions['formFieldChanged']>;

export type SecondaryMarketLiveTabContentPersistenceRequested = ReturnType<
  LiveInputFormActionFunctions['tabContentPersistenceRequested']
>;
export type SecondaryMarketLiveTabContentPersisted = ReturnType<LiveInputFormActionFunctions['tabContentPersisted']>;

export type SecondaryMarketLiveLinkedToCustodianRequested = ReturnType<
  LiveInputFormActionFunctions['custodianRequested']
>;
export type SecondaryMarketLiveLinkedToCustodianReceived = ReturnType<
  LiveInputFormActionFunctions['custodianReceived']
>;
export type SecondaryMarketLiveLinkedToCustodianFailed = ReturnType<
  LiveInputFormActionFunctions['custodianRequestFailed']
>;

export type SecondaryMarketLiveFormReset = ReturnType<LiveInputFormActionFunctions['resetForm']>;
export type SecondaryMarketLiveInputFormActions = ReturnType<
  LiveInputFormActionFunctions[keyof LiveInputFormActionFunctions]
>;
